import { FormGroup, ValidatorFn, Validators, FormControl } from '@angular/forms';
import { Injectable, OnInit } from '@angular/core';
import { FormField } from './formulario-relatorios';
import { of } from 'rxjs/internal/observable/of';



@Injectable({
  providedIn: 'root'
})
export class FormularioRelatorioControlService {

  constructor() { }
  formulario: FormGroup

  toFormGroup(inputs: FormField<string>[]): FormGroup {
    const group: any = {}
    inputs.forEach(input => {
      let validator: ValidatorFn[] = input.required ? [Validators.required] : [];
      switch (input.validator) {
        default:
          break;
      }
      group[input.key] = validator.length > 0 ? new FormControl(input.value || '', validator) : new FormControl(input.value || '')
    });
    return new FormGroup(group)
  }


  getFormFields(formulario?: FormField<string>[]) {

    let inputs: FormField<string>[] = []
      
    if (formulario) {

       inputs =[...inputs,...formulario]
    }

    return of(inputs.sort((a, b) => a.order - b.order));
  }

}
